"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToCamelCase = void 0;
var _lodash = _interopRequireDefault(require("lodash.camelcase"));
const convertToCamelCase = object => {
  if (Array.isArray(object)) {
    return object.map(convertToCamelCase);
  }
  if (typeof object === 'object' && object !== null && object.constructor === Object) {
    return Object.fromEntries(Object.entries(object).map(([key, value]) => [(0, _lodash.default)(key), convertToCamelCase(value)]));
  }
  return object;
};
exports.convertToCamelCase = convertToCamelCase;
